<template>
  <div class="container">
    <div v-if="$store.getters.user != null" class="row">
      <div class="col text-left">
        <button
          v-if="page == 2"
          class="btn btn-link"
          v-on:click="changePage(1)"
        >
          Back To Organization(s)
        </button>
      </div>
    </div>
    <div v-if="page == 1">
      <div
        class="row pt-3"
        v-for="(account, index) in accounts"
        :key="account.Account.Account_Id"
        v-bind:class="{ 'light-background': index % 2 === 1 }"
      >
        <div class="col">
          <div class="row">
            <div
              class="container"
              v-bind:id="'accountOrganizations' + account.Account.Account_Id"
            >
              <ManageOrganizationDetails
                v-bind:AccountType="account.Account.Account_Type"
                v-bind:AccountId="account.Account.Account_Id"
                v-bind:Permissions="permissions"
                v-bind:Organizations="account.Organizations"
                v-bind:AccountVariables="accountVariables"
                @manage-organization-permissions="manageOrganizationPermissions"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <UserPermissions
      v-if="page == 2"
      v-bind:Organization="permissionsOrganization"
    />
  </div>
</template>

<script>
import ManageOrganizationDetails from "@/components/Organization/ManageOrganizationDetails.vue";
import UserPermissions from "@/components/User/UserPermissions.vue";
//import $ from 'jquery';

export default {
  name: "OrganizationManagement",
  components: {
    ManageOrganizationDetails,
    UserPermissions
  },
  watch: {
    "$store.getters.user": async function() {
      this.loadMyOrganizations();
    }
  },
  data() {
    return {
      page: 1,
      accounts: [],
      permissionsOrganization: null,
      accountVariables: null,
      permissions: []
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    var view = this;
    await this.$getAccountVariables().then(variables => {
      view.accountVariables = variables;
    });
    await this.loadMyOrganizations();
  },
  methods: {
    async loadMyOrganizations() {
      var view = this;
      if (view.$store.getters.user != null) {
        this.$store.commit("updateLoading", true);
        view.permissions = await view.$getAllPermissions();
        this.$store.commit("updateLoading", true);
        await view.$getMyOrganizations().then(organizations => {
          var accounts = organizations.map(o => o.Account.Account_Id);
          var uniqueAccounts = accounts.filter((v, i, a) => a.indexOf(v) === i);
          view.accounts = [];
          uniqueAccounts.forEach(accountId => {
            var accountOrganizations = organizations.filter(
              o => o.Account.Account_Id == accountId
            );
            view.accounts.push({
              Account: accountOrganizations[0].Account,
              Organizations: accountOrganizations
            });
          });
          this.$store.commit("updateLoading", false);
        });
      }
    },
    manageOrganizationPermissions(organization) {
      this.permissionsOrganization = organization;
      this.changePage(2);
    },
    changePage(num) {
      switch (num) {
        case 1:
          this.page = num;
          this.permissionsOrganization = null;
          break;
        default:
          this.page = num;
          break;
      }
    }
  }
};
</script>
